import { render, staticRenderFns } from "./BtnExcluirItemRequisicao.vue?vue&type=template&id=58d8fc54"
import script from "./BtnExcluirItemRequisicao.vue?vue&type=script&lang=js"
export * from "./BtnExcluirItemRequisicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports